import React, { Fragment } from "react";
import { LanguageBarContainer } from "./styles";
import { Link } from "../Link";

interface Language {
  label: string;
  locale: string;
}

interface LanguageBarProps extends React.HTMLAttributes<HTMLDivElement> {
  activeLocale: string;
  languages: Language[];
}

export const LanguageBar = ({
  activeLocale,
  languages,
  ...props
}: LanguageBarProps) => {

  return (
    <LanguageBarContainer {...props}>
      {languages.map(({ label, locale }, index) => (
        <Fragment key={`language-btn-${index}`}>
          {index !== 0 && "|"}
          <Link
            href={"/"}
            locale={locale}
            style={{ fontWeight: activeLocale === locale ? 700 : 400 }}
          >
            {label}
          </Link>
        </Fragment>
      ))}
    </LanguageBarContainer>
  );
};
